import FieldController from '../field.controller';

class MoneyFieldController extends FieldController {

  get numericValue() {
    return this.value
  }

  set numericValue(value) {
    this.value = this._parseFloat(value, 2)
  }

  /**
   * This is a copy of the _parseFloat method from NumericFieldController
   */
  _parseFloat(value, maxDecimals = 2) {
    const stringValue = value && value.toString && value.toString() || value
    let parsedStringValue
    if (typeof stringValue === 'string' || stringValue instanceof String) {
      const result = stringValue.match(/^((\d*)(\.\d*)?)/);
      if (result) {
        const numPart = result[2]
        console.debug(`numPart:`, numPart)
        if (result[3] && result[3].length) {
          // We have decimals
          const decimalPart = result[3].substring(0, maxDecimals + 1)
          parsedStringValue = numPart + decimalPart
          console.debug(`decimalPart:`, decimalPart)
        } else {
          parsedStringValue = numPart
        }
      } else {
        parsedStringValue = ''
      }
    } else {
      parsedStringValue = ''
    }
    console.debug(`_parseFloat(${value}, ${maxDecimals}) returning ${parsedStringValue}`)
    return parseFloat(parsedStringValue)
  }
}

export default MoneyFieldController;
